import styled from 'styled-components';
import Input from '@material-ui/core/Input';

export const TagInput = styled(Input)`
    flex: 1;
`;
